import FizConfig from "../FizConfig.ts";
import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";

Html.registerWidget('widget/media-selector',{initDom,destroyDom:clear})

class MediaSelected{
  metaId :string
  url :string
  canDelete :boolean
  constructor(metaId :string,url :string,canDelete :boolean){
    this.metaId = metaId;
    this.url = url;
    this.canDelete = canDelete;
  }
}
class MediaSelection{
  array :  MediaSelected[]
  constructor(){
    this.array = [];
  }
  add(metaId :string,url :string,canDelete :boolean){
    for(var i=0;i< this.array.length;i++){
      var item = this.array[i];
      if(item.metaId===metaId){
        return false;
      }
    }
    this.array.push(new MediaSelected(metaId,url,canDelete));
  }
  remove(metaId :string){
    for(var i=0;i< this.array.length;i++){
      var item = this.array[i];
      if(item.metaId===metaId){
        this.array.splice(i,1);
        return true;
      }
    }
    return false;
  }
  contains(metaId :string){
    for(var i=0;i< this.array.length;i++){
      var item = this.array[i];
      if(item.metaId===metaId){
        return true;
      }
    }
    return false;
  }
  size(){
    return this.array.length;
  }
  canDeleteAll(){
    for(var i=0;i< this.array.length;i++){
      var item = this.array[i];
      if(!item.canDelete){
        return false;
      }
    }
    return true;
  }
  deleteAble(){
    return this.array.filter(it=>it.canDelete)
  }
  clear(){
    this.array = [];
  }
  onePicDownloadUrl(){
    if(this.array.length===1){
      return this.array[0].url;
    }
  }
}
export const selection = new MediaSelection();
var
  theToast;


async function selectiondelete(){
  if(!await modal.confirmDelete({
    title:"photos.confirmdeletetitle",
    message:selection.canDeleteAll()? 'photos.confirmdelete':'photos.confirmdeletenotadmin',
      no:"actions.cancel"
  })) return;

  var
    deleteAbleMetaId = selection.deleteAble().map(o=>o.metaId),
    count = deleteAbleMetaId.length;

  if(count>0){
    await ApiServer.metadelete(deleteAbleMetaId)
    modal.toastDone('photos.toastdeleted',count)

    clear();
    amplify.publish('newActivity');
  }else{
    clear();
  }
}

function selectiondownload(){
  var length = selection.size();
  if(length){
    var onePicDownloadUrl = selection.onePicDownloadUrl();
    if(onePicDownloadUrl){
      window.location.href = onePicDownloadUrl+"download";
    }else{

      //using fetch does not work because of cors
      //and we do not want to g=fetch, we want the browser to download
      document.body.insertAdjacentHTML('beforeend',`<form id='multipledownload' action='${FizConfig.API_BASE_URL}mediadownload' method='post'>
        <input type='submit'>
        ${selection.array.map(o=>`
          <input type='hidden' name='id' value='${decodeURIComponent(o.metaId)}'>`
        ).join('')}
      </form>`)

      var form = document.querySelector('#multipledownload') as HTMLFormElement
      form.submit()
      document.body.removeChild(form);

    }
  }
  clear();
}
Html.registerDom({
  selectiondelete,
  selectiondownload
})

async function updateToast(){
  var length = selection.size();
  if(length){
    if(!theToast){
      theToast = await modal.toast({
        emoji:'🖼️',
        text:'mediaselector.selected1',
        button:[
          {title:'actions.download',onclick:selectiondownload},
          {title:'actions.delete',onclick:(evt)=>{
              evt.stopPropagation()
              selectiondelete()
            }
          }
        ]
      },0);
      theToast.closed.then(clear);
    }
    const flexauto = theToast.domNode.querySelector('flexauto');
    if(flexauto) {
      flexauto.innerHTML = i18n.get(length>1?'mediaselector.selectedN':'mediaselector.selected1',length);
    }

    document.body.classList.add('media-selector-active')

  }else{
    theToast.close()
    theToast = undefined;
    document.body.classList.remove('media-selector-active')
  }
}

function onClick(this:HTMLElement, evt :Event){
  var
    mediaNode = Html.getDomMetaIdNode(this),
    metaId = Html.getDomMetaId(mediaNode);
  evt.preventDefault();
  evt.stopPropagation();
  if(this.classList.contains('media-selected')){
    this.classList.remove('media-selected');
    selection.remove(metaId);
  }else{
    this.classList.add('media-selected');
    selection.add(metaId,mediaNode.getAttribute("href"),mediaNode.getAttribute('data-fw-canDelete')==='true');
  }
  updateToast();
}

amplify.subscribe("sessionExpired pageUnload",clear);

export function initDom(mediaSelector: HTMLElement){
  const mediaNode = Html.getDomMetaIdNode(mediaSelector);
  const metaId = Html.getDomMetaId(mediaNode);
  //for restauring UI when active selection
  if(selection.contains(metaId)){
    mediaSelector.classList.add('media-selected');
  }
  mediaSelector.addEventListener('click',onClick)
}
export function clear(){
  if(selection.size()>0){
    selection.clear();
    document.querySelectorAll('.media-selected').forEach(element=>element.classList.remove('media-selected'));
    updateToast();
  }
}
